import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    _paq?: any[];
    OpenReplay?: any;
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
    pagemindAnalytics?: {
      track: (event: string, properties?: Record<string, any>) => void;
    };
  }
}

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route change
    const trackPageView = () => {
      const pageData = {
        page_path: location.pathname,
        page_search: location.search,
        page_title: document.title,
        page_location: window.location.href,
        timestamp: new Date().toISOString()
      };

      // Track with Matomo
      if (window._paq) {
        window._paq.push(['setCustomUrl', window.location.href]);
        window._paq.push(['setDocumentTitle', document.title]);
        window._paq.push(['trackPageView']);
      }

      // Track with OpenReplay
      if (window.OpenReplay) {
        window.OpenReplay.event('page_view', pageData);
      }

      // Track with PageMind Analytics (if available)
      if (window.pagemindAnalytics) {
        window.pagemindAnalytics.track('page_view', pageData);
      }

      // Log in development
      if (import.meta.env.MODE === 'development') {
        console.log('📊 Page View:', pageData);
      }
    };

    // Small delay to ensure page title is updated
    const timer = setTimeout(trackPageView, 100);

    return () => clearTimeout(timer);
  }, [location]);
};